export const ENDPOINTS = {
    ACCOUNTANT: {
        GET: '/accountants/:id',
    },
    AUTONOMOUS_REGIONS: {
        GET: '/AutonomousRegions',
    },
    COMPANY: {
        GET: '/users/:userId/companies',
        PUT: '/users/:userId/companies',
    },
    COMPANY_ACCOUNTS: {
        POST: '/companyaccounts',
        GET: {
            ALL: '/companyaccounts',
            SINGLE: '/companyaccounts/:id',
        },
        PUT: {
            STATUS: '/companyaccounts/:id/status/:status',
        },
    },
    COMPANY_ACCOUNTS_FILES: {
        GET: {
            ALL: '/companyaccounts/:companyAccountsId/files',
            DOWNLOAD_LINK: '/companyaccounts/:companyAccountsId/files/:fileId/downloadlink',
        },
        POST: '/companyaccounts/:companyAccountsId/files',
        DELETE: '/companyaccounts/:companyAccountsId/files/:fileId',
    },
    COMPANY_BOOK_LEGALIZATION: {
        POST: '/companybooklegalizations',
        GET: {
            ALL: '/companybooklegalizations',
            SINGLE: '/companybooklegalizations/:id',
        },
        PUT: {
            STATUS: '/companybooklegalizations/:id/status/:status',
        },
    },
    COMPANY_BOOK_LEGALIZATION_FILES: {
        GET: {
            ALL: '/companybooklegalizations/:companyBookLegalizationId/files',
            DOWNLOAD_LINK: '/companybooklegalizations/:companyBookLegalizationId/files/:fileId/downloadlink',
        },
        POST: '/companybooklegalizations/:companyBookLegalizationId/files',
        DELETE: '/companybooklegalizations/:companyBookLegalizationId/files/:fileId',
    },
    COMPANY_FILES: {
        GET: '/companyfiles',
        POST: '/companyfiles',
        GET_DOWNLOAD_LINK: '/companyfiles/:id/downloadlink',
        DELETE: '/companyfiles/:id',
    },
    COMPANY_TAX_RETURN: {
        POST: '/companytaxreturns',
        GET: {
            ALL: '/companytaxreturns',
            SINGLE: '/companytaxreturns/:id',
        },
        PUT: {
            STATUS: '/companytaxreturns/:id/status/:status',
        },
    },
    COMPANY_TAX_RETURN_FILES: {
        GET: {
            ALL: 'companytaxreturns/:companyTaxReturnId/files',
            DOWNLOAD_LINK: 'companytaxreturns/:companyTaxReturnId/files/:fileId/downloadlink',
        },
        POST: 'companytaxreturns/:companyTaxReturnId/files',
        DELETE: 'companytaxreturns/:companyTaxReturnId/files/:fileId',
    },
    CONSULTATION: {
        POST: {
            CREATE: '/consultations',
            CANCEL: '/consultations/cancel',
        },
        GET_NEXT: '/consultations/next',
    },
    COUNTRIES: {
        GET: '/countries',
    },
    CRYPTO_SESSION_URL: {
        GET: '/crypto/sessionuri/:taxReturnId',
    },
    CRYPTO_REPORT: {
        GET: '/crypto/reports/:taxReturnId',
        PUT: '/crypto/reports/:taxReturnId',
        PUT_CONFIRMATION: '/crypto/reports/:taxReturnId/confirmation',
    },
    EMPLOYMENTS: {
        GET: '/employments',
        PUT: '/employments/:id',
        POST: '/employments',
    },
    IDENTITY_VERIFICATION: {
        GET: '/identityverifications',
        POST: '/identityverifications',
        PUT: '/identityverifications/:id',
    },
    MUTUAL_SOCIETIES: {
        GET: '/mutualsocieties',
    },
    SOCIAL_SECURITY_PROFILE: {
        GET: '/socialsecurityprofiles/:userId',
        PUT: '/socialsecurityprofiles/:userId',
    },
    SUBSCRIPTION: {
        PUT: {
            TAX_REGIME: '/subscriptions/taxregime',
        },
    },
    SUBSCRIPTION_TIERS: {
        GET: '/subscriptions/tiers',
    },
    TAX_OFFICE_REFERENCE_NUMBER: {
        GET: '/taxoffice',
        POST: '/taxoffice/referencenumber',
    },
    TAX_RETURN_PRICES: {
        GET: '/taxreturns/prices',
    },
    AGREEMENTS: {
        GET: '/users/:userId/agreements',
    },
    DRAFT_AGREEMENTS: {
        GET: '/users/:userId/useragreements/draft',
    },
    PAYMENTS: {
        PENDING_COMPANY_FILING_FEES: {
            GET: '/payments/pending/companyfilingfees',
        },
    },
    PENDING_AGREEMENT: {
        GET: '/users/:userId/useragreements/pending',
    },
    PROFILE: {
        AUTHENTICATE: '/users/loggedin',
        GET: '/users/:userId',
        PUT: '/users/:userId',
        PUT_CUSTOMER_TYPE: '/users/:userId/customerType',
    },
    PUSH_NOTIFICATIONS: {
        PUT: {
            ON: '/mobiledevices/pushnotifications/on',
            OFF: '/mobiledevices/pushnotifications/off',
        },
    },
    QUARTERLY_TAX_RETURNS: {
        GET: {
            TAX_FORMS: '/quarterlytaxreturns/:quarterlyTaxReturnId/taxforms',
            DEADLINES: '/quarterlytaxreturns/deadlines',
        },
        PUT: {
            PAYMENT_PLAN: '/quarterlytaxreturns/:quarterlyTaxReturnId/paymentplan',
            TAX_FORM: '/quarterlytaxreturns/:quarterlyTaxReturnId/taxforms/:taxFormId',
        },
    },
    REFERRAL: {
        CAMPAIGN: '/referrals/campaign',
    },
    TAX_REGISTRATION: {
        GET: '/taxregistrations/:userId',
        PUT: '/taxregistrations/:userId',
        PUT_ACCOUNTANT: '/taxregistrations/:userId/accountant',
    },
    TEMPORARY_FILES: {
        POST: '/temporaryfiles',
    },
    USER: {
        POST: {
            REQUEST_PHONE_CALL: 'users/:userId/callme',
        },
        DELETE: {
            ACCOUNT: '/users/:userId',
        },
    },
    WORK_ACTIVITIES: {
        GET: {
            ALL: '/users/:userId/workactivities',
            SINGLE: '/users/:userId/workactivities/:workActivityId',
        },
        POST: '/users/:userId/workactivities',
        PUT: '/users/:userId/workactivities/:workActivityId',
    },
    WORK_ACTIVITY_REGISTRATIONS: {
        GET: {
            ALL: '/users/:userId/workactivities/:workActivityId/registrations',
            SINGLE: '/users/:userId/workactivities/:workActivityId/registrations/:workActivityRegistrationId',
        },
        POST: '/users/:userId/workactivities/:workActivityId/registrations',
        PUT: '/users/:userId/workactivities/:workActivityId/registrations/:workActivityRegistrationId',
    },
    WORK_ACTIVITY_REGISTRATION_FILES: {
        GET: {
            ALL: '/users/:userId/workactivities/:workActivityId/registrations/:workActivityRegistrationId/files',
            DOWNLOAD_LINK:
                '/users/:userId/workactivities/:workActivityId/registrations/:workActivityRegistrationId/files/:fileId/downloadlink',
        },
    },
} as const
